import {defineStore} from "pinia/dist/pinia";
import {deepClone} from "@/main";

export const useAclStore = defineStore('AclStore', {
    state() {
        return {
            aclState: [],
            appMenuState: [],
            breadcrumbMenuState: {}
        }
    },
    getters: {
        companyItalia() {
            return '328'
        },
        aclRules() {
            return this.aclState != null ? this.aclState : []
        },
        appMenu() {
            return this.appMenuState != null ? this.appMenuState : []
        },
        breadcrumbMenu() {
            return this.breadcrumbMenuState
        },
        roleLatitudiniDirezione: () => {
            return 'latitudini-direzione'
        },
        roleLatitudiniAgenzia: () => {
            return 'latitudini-agenzia'
        },
        roleLatitudiniAssicurato: () => {
            return 'latitudini-assicurato'
        }
    },
    actions: {
        createAclRules(user, vueInstance) {
            if (user != null && user.profile != null && user.profile.role != null && user.profile.companyCode != null) {
                app_Menu(vueInstance, user)
                appTopBar_ACL(user)
                manage_portfolio_ACL(user)
            }
        },
        setAclRules(aclRules) {
            this.aclState = aclRules
        },
        setAppMenu(menu) {
            this.appMenuState = menu
        },
        setBreadcrumbMenu(menuGroup) {
            this.breadcrumbMenuState = menuGroup
        },
        resetAcl() {
            this.aclState = []
        }
    }
})

function app_Menu(vueInstance, user) {
    const aclStore = useAclStore();
    const appMenu = []
    if (user.profile.role.code === aclStore.roleLatitudiniDirezione || user.profile.role.code === aclStore.roleLatitudiniAgenzia
    || user.profile.role.code === aclStore.roleLatitudiniAssicurato) {
        const latitudes = {
            label: vueInstance.$t('common.menu.latitudes'), icon: 'pi pi-bell', menugroup: 1,
            items: [{label: vueInstance.$t('common.menu.latitudeRequest'), icon: 'pi pi-euro', to: '/latitude_request', menugroup: 1},
                {label: vueInstance.$t('common.menu.managePortfolio'), icon: 'pi pi-file', to: '/manage_portfolio', menugroup: 1}],
        }
        appMenu.push(latitudes)
    }
    aclStore.setAppMenu(appMenu)
}

function appTopBar_ACL() {
    const aclStore = useAclStore();
    let aclRules = deepClone(aclStore.aclRules)
    aclStore.setAclRules(aclRules)
}

function manage_portfolio_ACL(user) {
    const aclStore = useAclStore();
    let aclRules = deepClone(aclStore.aclRules)
    if (user.profile.role.code === aclStore.roleLatitudiniDirezione ||
        user.profile.role.code === aclStore.roleLatitudiniAgenzia) {
        aclRules.push({elementId: "managePortfolio.massCancel", visible: true, editable: true});
    }
    if (user.profile.role.code === aclStore.roleLatitudiniAssicurato) {
        aclRules.push({elementId: "managePortfolio.massCancel", visible: false, editable: false});
    }
    aclStore.setAclRules(aclRules)
}